// extracted by mini-css-extract-plugin
module.exports = {"header":"Trends-module_header_2daf0","title":"Trends-module_title_a0d01","container":"Trends-module_container_d00da"};